import {
    buildSelectMultiplePromosModelInput,
    isPromozavrRouteAllowed,
    parsePromozavrQueryParams,
} from '../../../../../common/helpers';
import type { InitPromozavrPayload, PromozavrRendererSource, SelectMultiplePromosModelInput } from './types';

type ResolvedPromozavrInit = {
    request: SelectMultiplePromosModelInput;
    requestKey: string;
    rendererSource: PromozavrRendererSource;
};

type ResolvePromozavrInitArgs = InitPromozavrPayload & {
    lang?: string;
    tld?: string;
    testIds?: string[];
    isTouch?: boolean;
    isYandexNet: boolean;
    allowDebugParams?: boolean;
    shouldUsePaas: boolean;
    shouldUsePdokPromoRenderer: boolean;
};

export function resolvePromozavrInit(
    {
        pathname,
        search,
        requestKey,
        lang,
        tld,
        testIds = [],
        isTouch = false,
        isYandexNet,
        allowDebugParams = false,
        shouldUsePaas,
        shouldUsePdokPromoRenderer,
    }: ResolvePromozavrInitArgs,
    resolveRendererSource: (shouldUsePdokPromoRenderer: boolean) => PromozavrRendererSource
): ResolvedPromozavrInit | undefined {
    if (!shouldUsePaas || !isPromozavrRouteAllowed(pathname)) {
        return;
    }

    const promozavrQueryParams = parsePromozavrQueryParams(search);
    const promozavrDebugQueryParams = isYandexNet || allowDebugParams ? promozavrQueryParams : {};
    const request = buildSelectMultiplePromosModelInput({
        lang,
        tld,
        testIds,
        isTouch,
        ...promozavrDebugQueryParams,
        app: promozavrQueryParams.app,
    });

    return {
        request,
        requestKey,
        rendererSource: resolveRendererSource(shouldUsePdokPromoRenderer),
    };
}
